import { createSlice } from '@reduxjs/toolkit';
import { resetStore, resetStoreNoReload } from './loaderSlice';
const initialState = {
    botMessages: [],
    chatbotCollapsed: false,
};
export const chatbotSlice = createSlice({
    name: 'chatbot',
    initialState,
    reducers: {
        setBotMessages: (state, action) => {
            state.botMessages = action.payload;
        },
        setChatbotCollapsed: (state, action) => {
            state.chatbotCollapsed = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => initialState);
        builder.addCase(resetStoreNoReload, () => initialState);
    },
});
export const { setBotMessages, setChatbotCollapsed } = chatbotSlice.actions;
export default chatbotSlice.reducer;
